const mod = require('../bahabot.module.js')


function bahabotLayoutFactory() {
    let layout = "login";

    return {
        useLogin: function() {
            layout = "login";
        },
        useDashboard: function() {
            layout = "dashboard";
        },
        getLayout: function() {
            return layout;
        }
    }
}

mod.factory('LayoutService', bahabotLayoutFactory);
